import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Button,
} from '@cibli/shared';
import { useTranslation } from 'react-i18next';

type ConfirmBeContactedDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onClose?: () => void;
  onConfirm?: () => void;
};

export default function ConfirmBeContactedDialog({
  open,
  onOpenChange,
  onClose,
  onConfirm,
}: ConfirmBeContactedDialogProps) {
  const { t } = useTranslation();

  const handleClose = () => {
    onOpenChange(false);
    onClose?.();
  };

  const handleConfirm = () => {
    onOpenChange(false);
    onConfirm?.();
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="sm:min-w-2xl">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-2xl font-bold">
            {t('ConfirmBeContactedDialog.title')}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-lg">
            {t('ConfirmBeContactedDialog.description')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button size="lg" onClick={onConfirm ? handleConfirm : handleClose}>
            {t('ConfirmBeContactedDialog.close')}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
